import {closeAllModals, closeModal as close, openModal as open} from "Redux/actions/ui";
import {useDispatch, useSelector} from "react-redux";
import usePromotions from "Hooks/api/usePromotions";
import {useState} from "react";
import {useHistory} from "react-router-dom";
import {LOGIN_URL} from "Setup/urls";
import {IS_LOGGED_IN} from "Setup/config";
import {sendGA4Event, sendLaunchFirstDepositEvent} from "Helpers/gaEvents";

const useModal = (modalId = "") => {
    const history = useHistory();
    const [bankingLoading, setBankingLoading] = useState(false);
    const dispatch = useDispatch();
    const {_list} = usePromotions();
    const {execute: listUnclaimedPromotions} = _list();

    const {hasDeposited, optedInToWelcomeBonus} = useSelector(state => {
        let hasDeposited = false;
        let optedInToWelcomeBonus = false;

        if (IS_LOGGED_IN) {
            try {
                hasDeposited = state.morpheus.account.hasDeposited;
                const playerClaims = state.claims.playerClaims.isLoaded ? state.claims.playerClaims.claims : [];
                const welcomeBonusClaim = playerClaims.find(claim => claim.type === "WelcomeBonusOptIn");
                if (welcomeBonusClaim && welcomeBonusClaim.value === "true") {
                    optedInToWelcomeBonus = true;
                }
            } catch (e) {
                //sendExceptionToSentry(e);
                console.log(e);
            }
        }

        return {
            hasDeposited,
            optedInToWelcomeBonus
        }
    });

    const openModal = (overrideModalId = false, modalProps = {}, clearExistingModals = false) => {
        if (overrideModalId) {
            dispatch(open(overrideModalId, modalProps, clearExistingModals));
        } else if (modalId.length > 0) {
            dispatch(open(modalId, modalProps, clearExistingModals));
        }
    };

    const closeModal = (overrideModalId = false) => {
        if (overrideModalId) {
            dispatch(close(overrideModalId));
        } else if (modalId.length > 0) {
            dispatch(close(modalId));
        }
    };

    const closeModals = () => {
        dispatch(closeAllModals());
    };

    const launchBanking = async ({quickBanking = false, promoCode = false, specificAmount = false, slimBanking = false, additionalProps = {}} = {}) => {
        setBankingLoading(true);

        if (!promoCode && !hasDeposited && optedInToWelcomeBonus) {
            try {
                const promoType = "FirstDeposit";
                const res = await listUnclaimedPromotions({url: `?includeUnclaimable=false&type[]=${promoType}`});

                if (res.code === 200) {
                    const unclaimedFirstDepositBonus = res.data.items.find(promo => promo.bonusType === promoType);
                    if (unclaimedFirstDepositBonus) {
                        const welcomeBonusPromocode = unclaimedFirstDepositBonus.promoCode;

                        try {
                            if (welcomeBonusPromocode) {
                                sendLaunchFirstDepositEvent("FirstDeposit", welcomeBonusPromocode);
                            }
                        } catch (e) {
                            console.log("Something went wrong")
                        }

                        openModal('Banking', {quickBanking, promoCode: welcomeBonusPromocode, specificAmount, slimBanking});
                        setBankingLoading(false);
                        return;
                    }
                }
            } catch (e) {
                //sendExceptionToSentry(e);
                console.log(e);
            }
        }

        if (!promoCode) {
            sendGA4Event(`banking_launch`);
        } else {
            try {
                sendGA4Event(`banking_launch`, {
                    promo_code: promoCode
                });
            } catch (e) {
                console.log(e);
            }
        }

        openModal('Banking', {quickBanking, promoCode, specificAmount, slimBanking, ...additionalProps});
        setBankingLoading(false);
    };

    const launchWithdrawal = () => {
        openModal('Withdrawal');
    };

    const launchPromotionalTermsModal = () => {
        openModal('PromotionalTerms');
    };

    const launchLogin = () => {
        // openModal('Login');
        history.push(LOGIN_URL);
    };

    return {openModal, closeModal, closeModals, launchBanking, bankingLoading, launchWithdrawal, launchPromotionalTermsModal, launchLogin}
};

export default useModal;
